<template>
  <div>
    <div v-if="loading">
      <v-skeleton-loader class="mx-auto mt-5" type="card"></v-skeleton-loader>
      <v-skeleton-loader class="mx-auto mt-5" type="card"></v-skeleton-loader>
      <v-skeleton-loader class="mx-auto mt-5" type="card"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-toolbar class="mb-4" outlined elevation="0" rounded>
        <v-toolbar-title> Orçamentação </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="load()" :disabled="loading" icon>
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-menu>
          <template #activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              :loading="loadAdding"
              class=""
              color="primary"
              flat
              elevation="0"
            >
              <v-icon left>mdi-plus</v-icon>
              Adicionar
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="insured in insureds"
              :key="insured.id"
              @click="handleClickAdd(insured.id)"
            >
              <v-list-item-content>
                <v-list-item-title v-text="insured.contact.name" />
                <v-list-item-subtitle v-text="insured.type.description" />
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-row>
        <v-col
          v-for="budget in budgets"
          :key="budget.id"
          cols="12"
          sm="6"
          md="4"
        >
          <DnaBudgetCard
            :budget="budget"
            @click:remove="handleClickRemove(budget.id)"
            @change="load()"
          ></DnaBudgetCard>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import {
  indexByLead,
  store,
  destroy,
  accept,
  deny,
} from "@/services/dna_budgets";
import DnaBudgetCard from "../components/DnaBudgets/DnaBudgetCard.vue";

export default {
  mixins: [],

  components: {
    DnaBudgetCard,
  },

  props: {},

  data() {
    return {
      loading: false,
      budgets: [],
      loadAdding: false,
    };
  },

  methods: {
    async load() {
      this.budgets = [];
      const response = await indexByLead(this.lead.id);
      this.budgets = await response.data.data;
    },

    async handleClickAdd(participant_id) {
      this.loadAdding = true;

      try {
        const response = await store({
          lead_id: this.lead.id,
          participant_id,
        });
        this.$store.commit("sendMessage", {
          text: "Orçamentação adicionada",
        });
        this.$router.push({
          name: "dna-budget-details",
          params: { id: response.data.data.id },
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.loadAdding = false;
      }
    },

    async handleClickRemove(id) {
      if (!confirm("Remover orçamento?")) {
        return;
      }

      try {
        await destroy(id);
        this.load();
        this.$store.commit("sendMessage", {
          text: "Orçamentação removida",
        });
      } catch (error) {
        console.error(error);
      }
    },
  },

  computed: {
    lead() {
      return this.$store.getters["getLead"];
    },

    insureds: function () {
      if (!this.lead) return [];

      return this.lead.participants.filter(
        (participant) => participant.insured == true
      );
    },
  },

  created() {
    this.load();
  },
};
</script>
